import { Renewal } from "../interfaces/renewal_types"

export function isTooLate({renewal, status}: {renewal: Renewal, status: string}) {
    const isPermanentOrder = renewal.isAutoPay ?? false
    const tooLate = status === 'manual-instruction' || status === 'too-late'

    const isPayTooLate = tooLate && !isPermanentOrder
    const isCancelTooLate = tooLate && isPermanentOrder

    return {isPermanentOrder, tooLate, isPayTooLate, isCancelTooLate}
}